/**
 * Copy for the order-detail share sheet (JSAD-6877), exported so the Jest and Cypress
 * specs assert against these rather than duplicated literals — the same reason
 * `SharedItemConfirmModal` exports its strings.
 */

export const SHARE_SHEET_TITLE = 'Share your creations!';

export const SHARE_SHEET_BODY =
    'Copy a link for any item below and share your customized creations. Anyone who opens the link will instantly add the item to their bag.';

/** The header affordance that opens the sheet. */
export const SHARE_ENTRY_LABEL = 'Share';

/** Shown on a row for ~1.6s after its link is copied (web). */
export const SHARE_SHEET_COPIED_LABEL = 'Copied';

/** A line whose menu item is delisted, or an incomplete pick-two combo. */
export const SHARE_SHEET_UNAVAILABLE_LABEL = 'Not available';

export const SHARE_SHEET_UNAVAILABLE_HINT =
    'This item is not on the menu right now, so it cannot be shared.';

export const SHARE_SHEET_EMPTY =
    "None of these items are on the menu right now, so they can't be shared.";

export const SHARE_SHEET_ERROR = "We couldn't load the menu. Please try again.";

export const SHARE_SHEET_RETRY = 'Try again';

export const SHARE_SHEET_CLOSE_LABEL = 'Close';

/** How long a row stays in its `Copied` state before reverting. */
export const COPIED_RESET_MS = 1600;
